import React from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useI18nContext } from '@procore/core-react';
import { Business } from '../../types/business';
import { useStyles } from './BusinessProfileActivity.styles';
import { buildActivityDateInText } from '../../helpers/build-texts';
import StyledLink from '../ButtonsLinks/StyledLink';
import { Metrics } from '../../types/metrics-types';
import FreeActivityCard from './FreeActivityCard';
import PaidActivityCard from './PaidActivityCard';
import EmailObfuscationWrapper from '../utils/EmailObfuscationWrapper';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';

interface Props {
  business: Business;
  metrics: Metrics;
}

const BusinessProfileActivity = ({ business, metrics }: Props) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const joinedDate = buildActivityDateInText(business, I18n);
  let title = I18n.t('components.metrics.title', {
    Business: business.name,
  });
  title = joinedDate ? `${title} ${joinedDate}` : title;
  return (
    <Box data-test-id="business-profile-nav-activity" pt={3} pb={3}>
      <Typography className={classes.header} variant="h2">
        <EmailObfuscationWrapper>{title}</EmailObfuscationWrapper>
      </Typography>
      <AnalyticsWrappedComponent
        componentType={StyledLink}
        eventText="Clicked How are metrics calculated"
        eventLabel="How are metrics calculated"
        data-track-click="How are metrics calculated"
        href="https://support.procore.com/faq/what-activity-metrics-can-i-see-for-companies-listed-on-the-procore-construction-network"
        className={classes.headerLink}
      >
        <Typography className={classes.howAreMetricsCalculatedURL}>
          {I18n.t('components.metrics.how_are_metrics_calculated')}
        </Typography>
      </AnalyticsWrappedComponent>
      {business?.payingAccount ? (
        <PaidActivityCard metrics={metrics} />
      ) : (
        <FreeActivityCard metrics={metrics} />
      )}
    </Box>
  );
};

export default BusinessProfileActivity;
